// AboutTwo component - Converted from components/AboutTwo.vue
// About section variant with multiple images
// Converted: <template> -> JSX, :src -> src
import React from 'react';
import leftImg from '../assets/images/about/4.png';
import middleImg from '../assets/images/about/5.png';
import rightImg from '../assets/images/about/6.png';

const AboutTwo = () => {
  return (
    <section className="about_two">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6">
            <div className="block-title text-left">
              <p>A propos Leaders Agro Elite</p>
              <h3>Nous fournissons la meilleure solution</h3>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6">
            <div className="about_two_text">
              <p>
                Leaders agroelites sont des visionnaires qui transforment l&apos;agriculture
                moderne, notamment à travers la culture d&apos;olives. Ils allient innovation
                technologique et pratiques durables pour maximiser la production d&apos;olives
                de qualité tout en préservant l&apos;environnement.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-5 col-lg-5">
            <div className="about_two_left">
              <img src={leftImg} alt="about left" />
            </div>
          </div>
          <div className="col-xl-5 col-lg-5">
            <div className="about_two_middle">
              <img src={middleImg} alt="about middle" />
            </div>
          </div>
          <div className="col-xl-2 col-lg-2">
            <div className="about_two-right">
              <img src={rightImg} alt="about right" />
              <div className="about_two_content">
                <h2>SINCE 2026</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTwo;
